module.exports = __webpack_public_path__ + "img/icon-stock-in-out.2a1da7b3.png";